<bit-toggle-group
  fullWidth
  class="tw-mb-4"
  [selected]="credentialType$ | async"
  (selectedChange)="onCredentialTypeChanged($event)"
  attr.aria-label="{{ 'type' | i18n }}"
>
  <bit-toggle *ngFor="let option of passwordOptions$ | async" [value]="option.value">
    {{ option.label }}
  </bit-toggle>
</bit-toggle-group>
<bit-card class="tw-flex tw-justify-between tw-mb-4">
  <div class="tw-grow tw-flex tw-items-center">
    <bit-color-password class="tw-font-mono" [password]="value$ | async"></bit-color-password>
  </div>
  <div class="tw-flex tw-items-center tw-space-x-1">
    <button type="button" bitIconButton="bwi-generate" buttonType="main" (click)="generate$.next()">
      {{ "generatePassword" | i18n }}
    </button>
    <button
      type="button"
      bitIconButton="bwi-clone"
      buttonType="main"
      showToast
      [appCopyClick]="value$ | async"
    >
      {{ "copyPassword" | i18n }}
    </button>
  </div>
</bit-card>
<tools-password-settings
  class="tw-mt-6"
  *ngIf="(algorithm$ | async)?.id === 'password'"
  [userId]="this.userId$ | async"
  [disableMargin]="disableMargin"
  (onUpdated)="generate$.next()"
/>
<tools-passphrase-settings
  class="tw-mt-6"
  *ngIf="(algorithm$ | async)?.id === 'passphrase'"
  [userId]="this.userId$ | async"
  (onUpdated)="generate$.next()"
  [disableMargin]="disableMargin"
/>
